import React, { useState, useEffect } from "react"
import { navigate } from "gatsby"
import { FormikWizard } from "formik-wizard"
import { useToasts } from "react-toast-notifications"
import { PaystackButton } from "react-paystack"
import { sendNotification, notifyUser } from "../../Helpers"
import IncorpIcon from "../../../images/business/company-incor.svg"


import steps from "./steps"
import CompanyRegistrationWrapper from "./CompanyRegistrationWrapper"
import Summary from "./views/Summary"
import BusinessTitleCard from "../BusinessCardTitle"

const StartApplication = () => {
  const { addToast } = useToasts()
  const [config, setConfig] = useState({})
  const [shareholders, setShareholders] = useState([])
  const [loading, setLoading] = useState(false)

  const [showSummary, setShowSummary] = useState(false)

  const [businessData, setBusinessData] = useState([])

  const getSteps = async () => {
    setLoading(true)
    const step1 = await fetch(
      `${
        process.env.DIY_BASE_URL
      }/api/order/v1/CompanyIncorporation/step1?order-ref=${localStorage.getItem(
        "orderReference"
      )}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Token ${localStorage.getItem("dd_token")}`,
        },
      }
    ).then((response) => response.json())

    const step2 = await fetch(
      `${
        process.env.DIY_BASE_URL
      }/api/order/v1/CompanyIncorporation/step2?order-ref=${localStorage.getItem(
        "orderReference"
      )}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Token ${localStorage.getItem("dd_token")}`,
        },
      }
    ).then((response) => response.json())

    setBusinessData(step1)
    setShareholders(step2)

    setLoading(false)
    setShowSummary(true)
  }
  const onClose = () => {
    console.log("closed")
  }

  // Submit Data
  const handleSubmit = async (values) => {
    await getSteps()
  }

  const createRecord = async () => {
    sendNotification({
      to: "indy@sparkle.ng",
      cc: "hello@diylaw.ng",
      from: "indy@sparkle.ng",
      // subject: `New Company Incorporation By ${shareholders[0].firstname} ${shareholders[0].lastname}`,
      // templateId: "d-931d7904508c488296cbcaf2cb60b93b",
      // dynamicTemplateData: {
      //   subject: `New Company Incorporation By ${shareholders[0].firstname} ${shareholders[0].lastname}`,
      //   name: `${shareholders[0].firstname} ${shareholders[0].lastname}`,
      //   email: shareholders[0].shareholder_email,
      //   service: "Company Incorporation",
      // },
    })

    addToast("Application Successful", {
      appearance: "success",
      placement: "top-center",
      autoDismiss: true,
    })

    notifyUser({
      // to: shareholders[0].shareholder_email,
      // from: "indy@sparkle.ng",
      // subject: `Company Incorporation At Sparkle`,
      // templateId: "d-f70dd4b4ed1a47b794a4ef3b66b5ea5c",
      // dynamicTemplateData: {
      //   subject: `Company Incorporation At Sparkle`,
      //   name: shareholders[0].firstname,
      //   service: "Company Incorporation",
      // },
    })

    sendNotification({
      // to: "indy@sparkle.ng",
      // cc: "hello@diylaw.ng",
      // from: "indy@sparkle.ng",
      // subject: `Payment Verified for ${shareholders[0].firstname} ${shareholders[0].lastname}`,
      // templateId: "d-0f2918f7a8024ab7a6a7ab0a0a34dcde",
      // dynamicTemplateData: {
      //   subject: `Payment Verified for ${shareholders[0].firstname} ${shareholders[0].lastname}`,
      //   name: `${shareholders[0].firstname} ${shareholders[0].lastname}`,
      //   email: shareholders[0].shareholder_email,
      //   service: "Company Incorporation",
      // },
    })

    localStorage.clear()
    setLoading(false)
    setTimeout(function () {
      navigate("/business-support/get-started")
    }, 1000)
  }

  const onSuccess = async () => {
    await createRecord()
  }

  const initPayment = async () => {
    var min = 10000000000000
    var max = 99999999999999

    var payoutRef = Math.round(Math.random() * (max - min) + min).toString()

    let payload = {
      reference: payoutRef,
      email: shareholders[0].shareholder_email,
      amount: 4800000,
      metadata: {
        custom_fields: [
          {
            display_name: "Business Support Service",
            variable_name: "Business Support Service",
            value: "Company Incorporation",
          },
        ],
      },
      publicKey: process.env.PAYSTACK_KEY,
      text: "Pay with Card",
    }

    await setConfig({ ...config, ...payload })
    document.querySelector("button.paystack").click()
  }

   const componentProps = {
    //  email: shareholders[0].shareholder_email,
     amount: 4800000,
     metadata: {
       custom_fields: [
         {
           display_name: "Business Support Service",
           variable_name: "Business Support Service",
           value: "Company Incorporation",
         },
       ],
     },
     text: "Pay with Card",
     publicKey: process.env.PAYSTACK_KEY,
     onSuccess: (reference) => onSuccess(reference),
     onClose: onClose,
   }


  return (
    <div>
      <div className={!showSummary ? "container" : "container d-none"}>
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <BusinessTitleCard
              icon={IncorpIcon}
              title="Company incorporation"
              subtitle="Officially register your company or in corporation, get CAC and a TIN"
            />
            <div className="business-suport-card my-lg-5 waitlist__form ">
              <FormikWizard
                steps={steps}
                onSubmit={handleSubmit}
                render={CompanyRegistrationWrapper}
              />
            </div>
          </div>
        </div>
      </div>

      <PaystackButton {...componentProps} className="btn paystack d-none" />

      {showSummary && (
        <Summary
          businessData={businessData}
          shareholders={shareholders}
          payFee={initPayment}
          setShowSummary={setShowSummary}
          setLoading={setLoading}
          loadingStatus={loading}
        />
      )}
    </div>
  )
}

export default StartApplication
